import { render } from "./edit-form.vue?vue&type=template&id=716f966e&scoped=true"
import script from "./edit-form.vue?vue&type=script&lang=js"
export * from "./edit-form.vue?vue&type=script&lang=js"

import "./edit-form.vue?vue&type=style&index=0&id=716f966e&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-716f966e"]])

export default __exports__